<template>
  <div class="col-12 col-md-1">
    <ol class="step-progress-indicator__steps">
        <li
          class="step-progress-indicator__number-wrapper"
          v-for="n in steps"
          :class="stepIndicator(n)"
          @click="move(n)">
          <span class="step-progress-indicator__number">{{n}}</span>
        </li>
    </ol>
  </div>
</template>

<script>
  export default {
    name: "UXStepProgressIndicator",
    props: {
      steps: {
        type: Number,
        required: true,
        validator (value) {
          return 0 < value;
        }
      },
      currentStep: {
        type: Number,
        default: 1,
        validator (value) {
          return 0 < value;
        }
      },
      additionalClassSteps: Array,
      additionalClass: String
    },
    methods: {
      move (step) {
        this.$emit('move', step);
      },
      stepIndicator (step) {
        let additionalClass = '';
        if (this.additionalClassSteps && this.additionalClassSteps.includes(step)) {
          additionalClass = this.additionalClass;
        }
        return {
          ['step-progress-indicator__step--passed']: this.currentStep > step && !additionalClass,
          ['step-progress-indicator__step--active']: this.currentStep === step && !additionalClass,
          ['step-progress-indicator__step--passed--error']: (this.currentStep > step || this.currentStep < step) && additionalClass,
          ['step-progress-indicator__step--active--error']: this.currentStep === step && additionalClass,
        }
      }
    }
  };
</script>
